import React from 'react';

const Hall = () => {
    return (
        <div>

        </div>
    );
};

export default Hall;